// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__00jp1","requiresAction":"styles_requiresAction__7u3rS","avatar":"styles_avatar__MBgc8","secondaryText":"styles_secondaryText__vJcHa"};